// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var SurveyTheme$ReactHooksTemplate = require("./surveyTheme.res.js");
var SmileyRating$ReactHooksTemplate = require("./smileyRating.res.js");
var RatingSmileySet$ReactHooksTemplate = require("./ratingSmileySet.res.js");
var MandatoryMessage$ReactHooksTemplate = require("./MandatoryMessage.res.js");
var QuestionTextPreview$ReactHooksTemplate = require("./QuestionTextPreview.res.js");

function SmileyRatingPreview(props) {
  var onChange = props.onChange;
  var surveyTheme = props.surveyTheme;
  var smileyRating = props.smileyRating;
  var style = function (selected) {
    if (selected) {
      return {
              borderColor: SurveyTheme$ReactHooksTemplate.nextButtonColor(surveyTheme),
              borderWidth: "1px",
              outline: "None"
            };
    } else {
      return {
              outline: "None"
            };
    }
  };
  var smileyButton = function (ratingType, ratingSmileySet, selected) {
    return JsxRuntime.jsxs("button", {
                children: [
                  JsxRuntime.jsx("span", {
                        children: JsxRuntime.jsx("img", {
                              src: SmileyRating$ReactHooksTemplate.ratingTypeToImage(ratingType, ratingSmileySet)
                            }),
                        className: "text-5xl small:text-4xl"
                      }),
                  SmileyRating$ReactHooksTemplate.showLabels(smileyRating) ? JsxRuntime.jsx("div", {
                          children: SmileyRating$ReactHooksTemplate.ratingTypeToString(ratingType),
                          className: "text-xs"
                        }) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                ],
                className: "animated bounceIn flex flex-col items-center p-2 gap-1",
                style: style(selected),
                onClick: (function (e) {
                    e.preventDefault();
                    Curry._1(onChange, SmileyRating$ReactHooksTemplate.setAnswer(smileyRating, ratingType));
                  })
              }, String(SmileyRating$ReactHooksTemplate.ratingTypeToRating(ratingType)));
  };
  var onTitleChange = function (html) {
    Curry._1(onChange, SmileyRating$ReactHooksTemplate.setText(smileyRating, html));
  };
  var onDescriptionChange = function (html) {
    Curry._1(onChange, SmileyRating$ReactHooksTemplate.setDescription(smileyRating, html));
  };
  var match = SmileyRating$ReactHooksTemplate.ratingSmileySet(smileyRating);
  var tmp;
  if (match !== undefined) {
    var ratingSmileySet = SmileyRating$ReactHooksTemplate.ratingSmileySet(smileyRating);
    tmp = JsxRuntime.jsxs("div", {
          children: [
            JsxRuntime.jsx(QuestionTextPreview$ReactHooksTemplate.make, {
                  text: SmileyRating$ReactHooksTemplate.text(smileyRating),
                  description: SmileyRating$ReactHooksTemplate.description(smileyRating),
                  onTitleChange: onTitleChange,
                  onDescriptionChange: onDescriptionChange
                }),
            JsxRuntime.jsx("div", {
                  children: ratingSmileySet !== undefined ? $$Array.of_list(Belt_List.map(SmileyRating$ReactHooksTemplate.ratingTypeCollection(smileyRating), (function (xs) {
                                var match = SmileyRating$ReactHooksTemplate.answer(smileyRating);
                                var match$1 = RatingSmileySet$ReactHooksTemplate.selectedStateRatingSmileySet(ratingSmileySet);
                                if (match !== undefined) {
                                  if (match$1 !== undefined) {
                                    return smileyButton(xs, xs === match ? match$1 : ratingSmileySet, false);
                                  } else {
                                    return smileyButton(xs, ratingSmileySet, xs === match);
                                  }
                                } else {
                                  return smileyButton(xs, ratingSmileySet, false);
                                }
                              }))) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                  className: "flex w-full justify-between pb-5"
                }),
            JsxRuntime.jsx("div", {
                  children: props.mandatory ? JsxRuntime.jsx(MandatoryMessage$ReactHooksTemplate.make, {}) : JsxRuntime.jsx(JsxRuntime.Fragment, {})
                })
          ],
          className: "w-full p-16"
        });
  } else {
    tmp = JsxRuntime.jsx("p", {
          children: "Loading..."
        });
  }
  return JsxRuntime.jsx("div", {
              children: tmp
            });
}

var make = SmileyRatingPreview;

exports.make = make;
/* react/jsx-runtime Not a pure module */
